<div class="login-page">
  <div class="brand">
    <app-jamar-logo [ancho]="150" [alto]="32" />
    <div class="fair-title">FERIA CHINA 2026</div>
  </div>

  <div class="login-card">
    <h1 class="login-title">Bienvenido</h1>
    <p class="login-subtitle">Inicia sesión para continuar</p>

    @if (!supabaseConfigurado) {
      <p class="demo-note">
        Modo demo: sin proyecto Supabase configurado todavía. Pulsa "Iniciar sesión" para explorar con datos de ejemplo.
      </p>
    }

    <form (submit)="enviar($event)" class="login-form">
      <div class="field">
        <label for="login-email" class="input-label">Correo electrónico</label>
        <input
          id="login-email"
          type="email"
          autocomplete="email"
          [ngModel]="email()"
          (ngModelChange)="email.set($event)"
          name="email"
          [required]="supabaseConfigurado"
          class="login-input"
        />
      </div>

      <div class="field">
        <label for="login-password" class="input-label">Contraseña</label>
        <div class="password-wrapper">
          <input
            id="login-password"
            [type]="mostrarPassword() ? 'text' : 'password'"
            autocomplete="current-password"
            [ngModel]="password()"
            (ngModelChange)="password.set($event)"
            name="password"
            [required]="supabaseConfigurado"
            class="login-input"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="mostrarPassword.set(!mostrarPassword())"
            [attr.aria-label]="mostrarPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          >
            @if (mostrarPassword()) {
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                <line x1="2" y1="2" x2="22" y2="22" />
              </svg>
            } @else {
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            }
          </button>
        </div>
      </div>

      <div class="remember-row">
        <label class="remember-label">
          <input type="checkbox" class="remember-checkbox" [checked]="recordarme()" (change)="recordarme.set(!recordarme())" />
          Recordarme
        </label>
      </div>

      @if (error()) {
        <p class="error-text">{{ error() }}</p>
      }

      <button type="submit" class="login-button" [disabled]="cargando()">
        {{ cargando() ? 'Iniciando sesión…' : 'Iniciar sesión' }}
      </button>
    </form>

    @if (entraConfigurado) {
      <div class="divider">o continúa con</div>
      <button type="button" class="secondary-button" (click)="entrarConMicrosoft()" [disabled]="cargandoMicrosoft()">
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
          <rect x="0" y="0" width="7" height="7" fill="#F25022" />
          <rect x="9" y="0" width="7" height="7" fill="#7FBA00" />
          <rect x="0" y="9" width="7" height="7" fill="#00A4EF" />
          <rect x="9" y="9" width="7" height="7" fill="#FFB900" />
        </svg>
        {{ cargandoMicrosoft() ? 'Conectando…' : 'Entrar con cuenta Microsoft de Jamar' }}
      </button>
    }

    <a class="back-link" routerLink="/">← Volver a elegir módulo</a>
  </div>

  <div class="brand-message">
    <svg class="brand-message-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z" />
    </svg>
    <div>
      <div class="brand-message-text">Conectamos oportunidades, productos y mercados</div>
      <div class="platform-label">● Plataforma Oficial de Gestión</div>
    </div>
  </div>

  <div class="footer">© 2026 Jamar. Todos los derechos reservados.</div>
</div>
